import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function Page404() {
  const navigator = useNavigate();
  return <>
    <main class="flex min-h-[100vh] justify-center items-center p-4">
      <div class="text-center">
        <p class="text-base font-semibold text-[#AF0056]">404</p>
        <h1 class="mt-4 text-5xl font-semibold tracking-tight text-balance text-gray-900 sm:text-7xl">Page not found</h1>
        <p class="mt-6 text-lg font-medium text-pretty text-gray-500 sm:text-xl/8">Sorry, we couldn’t find the page you’re looking for.</p>
        <div class="mt-10 flex items-center justify-center gap-x-6">
          <a href="javascript:;" class="inline-flex items-center justify-center gap-2 them-primary-btn whitespace-nowrap focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-primary/90 h-10 bg-primary text-primary-foreground hover:opacity-90 rounded-full px-8 py-6 text-lg font-semibold shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105 w-full"
            onClick={() => navigator('/user/creator-list')}>Go back home</a>
        </div>
      </div>
    </main>
  </>;
}
